import { designTokens, styled } from '@project44/manifest-ds';

export const ScrollPanel = styled('div', {
  overflow: 'auto',
  margin: '$medium',
  borderRadius: '$small',
  boxShadow: '$small',
  '& > *': {
    paddingLeft: '$medium',
    paddingRight: '$medium',
  },
});

export const collapsiblePanel = {
  borderLeftWidth: '1px',
  borderLeftStyle: 'solid',
  borderLeftColor: designTokens.colorBorderPrimary,
};
